__turbopack_context__.v({
  "border_right": "StatsContainerLp-module-scss-module__02Zsca__border_right",
  "statics_container": "StatsContainerLp-module-scss-module__02Zsca__statics_container",
  "stats": "StatsContainerLp-module-scss-module__02Zsca__stats",
  "text1": "StatsContainerLp-module-scss-module__02Zsca__text1",
  "text2": "StatsContainerLp-module-scss-module__02Zsca__text2",
});
